//import React, { useRef, useEffect, useState} from 'react';

import React, { useRef, useEffect} from 'react';
import {substances, models,binary_sys} from './physical_models.js';

import * as d3 from 'd3';

const CN = 0;
//const EN = 1;

export function OutputGraph({bgData, data, tMax, tMin, lang}) {
    const chartRef = useRef(null);
    const width = 320, height = 280;

    const xory_cap_cn = 'x1/y1', xory_cap_en = 'x1/y1';
    const xory_cap = (lang===CN) ? xory_cap_cn : xory_cap_en;

    const temp_cap_cn = '温度', temp_cap_en = 'Temperature';
    const temp_cap = (lang===CN) ? temp_cap_cn : temp_cap_en;
    const {x1s, y1s, Tbs} = bgData;

    const  axisScale='linear';

    useEffect( ()=> {

        const margin = { top: 20, right: 30, bottom: 40, left: 40 };


        const svg = d3.select(chartRef.current);
        svg.selectAll('*').remove();
     

        const xScale = d3.scaleLinear()
                        .domain([0, 1])
                        .range([margin.left, width-margin.right]);
        
        
        let yScale = d3.scaleLinear()
                        .domain([tMin, tMax])
                        .range([height-margin.bottom, margin.top]);
        
        if (axisScale === 'log') yScale = d3.scaleLog()
                                            .domain([1e-3, 10])
                                            .range([height-margin.bottom, margin.top]);

        if (x1s.length >0) {

            const linex = d3.line()
                           .x((d,i)=>xScale(x1s[i]))
                           .y((d,i)=>yScale(Tbs[i]-273.15));

            const liney = d3.line()
                           .x((d,i)=>xScale(y1s[i]))
                           .y((d,i)=>yScale(Tbs[i]-273.15));

            svg.append("path").datum(Tbs)
               .attr("stroke", "blue").attr("fill",'none').attr("d",linex);
            svg.append("path").datum(Tbs)
               .attr("stroke", "red").attr("fill",'none').attr("d",liney);
        }

        if (data.length >0) {

            svg.selectAll('.x1Tb-points')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', 'x1Tb-points')
            .attr('cx', (d, i) => xScale(d.x1))
            .attr('cy', (d, i) => yScale(d.Tb-273.15))
            .attr('r', 2)
            .attr('fill', 'blue');
      
          svg.selectAll('.y1Tb-points')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', 'y1Tb-points')
            .attr('cx', (d, i) => xScale(d.y1))
            .attr('cy', (d, i) => yScale(d.Tb-273.15))
            .attr('r', 2)
            .attr('fill', 'red');
        }

        const XaxisGenerator = d3.axisBottom(xScale);
        svg.append("g").call(XaxisGenerator).attr('transform', `translate(0,${height - margin.bottom})`);

        const XaxisGenerator2 = d3.axisTop(xScale);
        svg.append("g").call(XaxisGenerator2).attr('transform', `translate(0,${margin.top})`);

        const YaxisGenerator = d3.axisLeft(yScale);
        svg.append("g").call(YaxisGenerator).attr('transform', `translate(${margin.left},0)`);

        const YaxisGenerator2 = d3.axisRight(yScale);
        svg.append("g").call(YaxisGenerator2).attr('transform', `translate(${width - margin.right},0)`);

        svg.append("text")             
            .attr("transform", `translate(${width/2},${height-8})`)
            .style("text-anchor", "middle") // Centers the text above the axis
            .text(xory_cap);

        svg.append("text")
            .attr("transform", `translate(${12},${height/2-8}), rotate(-90)`) // Rotates the text -90 degrees
            .style("text-anchor", "middle") // Ensures the text is centered after rotation
            .text(temp_cap + '/°c' );


    }, [bgData,lang]);




    return (
        <div>
            <svg width={width+'px'} height={height+'px'} ref={chartRef} />
        </div>
    );
}




export function OutputGraph_xy({bgData, data ,lang}) {
    const chartRef = useRef(null);
    const width = 290, height = 280;

    const x1_cap_cn = 'x1', x1_cap_en = 'x1';
    const x1_cap = (lang===CN) ? x1_cap_cn : x1_cap_en;

    const y1_cap_cn = 'y1', y1_cap_en = 'y1';
    const y1_cap = (lang===CN) ? y1_cap_cn : y1_cap_en;
    const {x1s, y1s} = bgData;


    const  axisScale='linear';

    useEffect( ()=> {

        const margin = { top: 20, right: 30, bottom: 40, left: 40 };


        const svg = d3.select(chartRef.current);
        svg.selectAll('*').remove();
     
        const xScale = d3.scaleLinear()
                        .domain([0, 1])
                        .range([margin.left, width-margin.right]);
        
        
        let yScale = d3.scaleLinear()
                        .domain([0,1])
                        .range([height-margin.bottom, margin.top]);
        
        if (axisScale === 'log') yScale = d3.scaleLog()
                                            .domain([1e-3, 10])
                                            .range([height-margin.bottom, margin.top]);

        if (x1s.length >0) {

            const line_x_x = d3.line()
                           .x((d,i)=>xScale(x1s[i]))
                           .y((d,i)=>yScale(x1s[i]));

            const line_y_x = d3.line()
                           .x((d,i)=>xScale(x1s[i]))
                           .y((d,i)=>yScale(y1s[i]));

            svg.append("path").datum(x1s)
               .attr("stroke", "black").attr("fill",'none').attr("d",line_x_x);
            svg.append("path").datum(y1s)
               .attr("stroke", "blue").attr("fill",'none').attr("d",line_y_x);
        }

        if (data.length >0) {

            svg.selectAll('.x1Tb-points')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', 'x1Tb-points')
            .attr('cx', (d, i) => xScale(d.x1))
            .attr('cy', (d, i) => yScale(d.y1))
            .attr('r', 2)
            .attr('fill', 'red');

        }

        const XaxisGenerator = d3.axisBottom(xScale);
        svg.append("g").call(XaxisGenerator).attr('transform', `translate(0,${height - margin.bottom})`);

        const XaxisGenerator2 = d3.axisTop(xScale);
        svg.append("g").call(XaxisGenerator2).attr('transform', `translate(0,${margin.top})`);

        const YaxisGenerator = d3.axisLeft(yScale);
        svg.append("g").call(YaxisGenerator).attr('transform', `translate(${margin.left},0)`);

        const YaxisGenerator2 = d3.axisRight(yScale);
        svg.append("g").call(YaxisGenerator2).attr('transform', `translate(${width - margin.right},0)`);

        svg.append("text")             
            .attr("transform", `translate(${width/2},${height-8})`)
            .style("text-anchor", "middle") // Centers the text above the axis
            .text(x1_cap);

        svg.append("text")
            .attr("transform", `translate(${12},${height/2-8}), rotate(-90)`) // Rotates the text -90 degrees
            .style("text-anchor", "middle") // Ensures the text is centered after rotation
            .text(y1_cap);

            /*
     
        svg.append('g')
          .attr('transform', `translate(0,${margin.top})`)
          .call(d3.axisLeft(y).ticks(null).tickSizeOuter(0));
          */

    }, [bgData,lang]);



    return (
        <div>
            <svg width={width+'px'} height={height+'px'} ref={chartRef} />
        </div>
    );
}


export function OutputTable({data, lang}){

    const columns_cn = ['','Tb(C)','x1','y1'];
    const columns_en = ['','Tb(C)','x1','y1'];
    const cols = (lang===CN)?columns_cn: columns_en;
    const result_cap_cn = '暂无计算结果', result_cap_en = 'No computed results yet';
    const result_cap = (lang===CN)?result_cap_cn: result_cap_en;

    return (
        <div>

        {(data.length===0)?
        <tr align='center'>
            {result_cap}
        </tr>
        :
        <div>

        <br/>

        <tr className="underscore-row" align="center">
            <td width="20px">{cols[0]}</td>
            <td width="60px">{cols[1]}</td>
            <td width="60px">{cols[2]}</td>
            <td width="60px">{cols[3]}</td>
        </tr>


        {data.map((s0,i)=>{
            //test
                let {P,x1,y1,Tb} = s0 ;
                Tb = parseFloat(s0.Tb)-273.15;
                x1 = parseFloat(s0.x1);
                y1 = parseFloat(s0.y1);
                let T = Tb.toFixed(2),x = x1.toFixed(3),y = y1.toFixed(3);

            return (

                <tr className="underscore-row2">
                    <td className="tableData" padding='2px' align="right">{i+1}</td>
                    <td className="tableData" padding="2px" align="right">{T}</td>
                    <td className="tableData" padding="2px" align="center">{x}</td>
                    <td className="tableData" padding="2px" align="center">{y}</td>                
                </tr>
                
            )
        })}

        
        </div>
         }
        </div>
    )}

export function convertDataToCSV(data, lang, fileType) {

    const columns_en = 'Model,Comp_1,Comp_2,P0(bar),Tb(C),x1,y1';
    const cols = columns_en;
    // "data" like : {P: P_in, x1: x1_in, y1: ans.y1, Tb: ans.T_bubble, model:selectedModel, system:selectedSystem}
    switch (fileType){
        case 'csvfile':
            const csvRows = [cols,
            ...data.map(d=>{

                const press = parseFloat(d.P).toFixed(3);
                const temp = parseFloat(d.Tb-273.15).toFixed(3);
                const x1 = parseFloat(d.x1).toFixed(4);
                const y1 = parseFloat(d.y1).toFixed(4);
                const model = d.model;
                const {comp_1, comp_2} = binary_sys[model][d.system];
                const comp_1en = substances[comp_1].name_en, comp_2en = substances[comp_2].name_en;

              return (
                 model+',' + comp_1en +','+ comp_2en + ',' + press +','+ temp +',' + x1 + ',' + y1
              );
              })
          ];
          return csvRows.join('\n'); 

        default:
            console.log('Wrong downloading file type')
    }

  }

export function downloadCSV(data, lang, filename = 'TxyData.csv', fileType) {
    const csvData = convertDataToCSV(data, lang, fileType);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    
    // Create an anchor element and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link); // Append link to the body
    link.click(); // Programmatically click the link to trigger the download
    
    document.body.removeChild(link); // Clean up and remove the link
    URL.revokeObjectURL(url); // Release the object URL
  }
  
export function DataDownload({data, prompt, fileType, lang}) {
    const handleDownload = () => {
      downloadCSV(data, lang, 'TxyData.csv', fileType); // Call the download function with your data and a filename
    };
  
    return (
      <button onClick={handleDownload}>{prompt}</button>
    );
  }


export function OutputTable_Compare({compareData, lang}){

    //{x1: d.x1, y1e: d.y1, y1d: y1-d.y1, Tbe: d.Tb, Tbd: T_bubble-d.Tb}
    const result_cap_cn = '暂无上传实验数据', result_cap_en = 'No exp data points uploaded yet';
    const result_cap = (lang===CN)?result_cap_cn: result_cap_en;

    return (
        <div>

        {(compareData.length===0)?
        <tr align='center'>
            {result_cap}
        </tr>
        :
        <div className="tableData2">

        <br/>

        <tr className="underscore-row" align="center">
            <td width="40px"><i>x</i><sub>1</sub></td>
            <td width="40px"><i>y</i><sub>1</sub><sup>exp</sup></td>
            <td width="40px">&Delta;<i>y</i><sub>1</sub></td>
            <td width="40px"><i>T</i><sub>b</sub><sup>exp</sup></td>
            <td width="40px">&Delta;<i>T</i><sub>b</sub></td>
        </tr>

        {compareData.map((d)=>{
            return (

                <tr className="underscore-row2">

                    <td className="tableData2" padding="2px" align="right">{d.x1.toFixed(3)}</td>
                    <td className="tableData2" padding="2px" align="right">{d.y1e.toFixed(3)}</td>
                    <td className="tableData2" padding="2px" align="right">{d.y1d.toFixed(3)}</td>
                    <td className="tableData2" padding="2px" align="right">{(d.Tbe-273.15).toFixed(1)}</td>
                    <td className="tableData2" padding="2px" align="right">{d.Tbd.toFixed(1)}</td>                 
                </tr>
                
            );

        })}
        </div>
        }

        </div>
    )

}

export const fileFormats = {
    'csvfile': {name_cn: 'CSV文件 (带表头)',
                name_en: 'CSV File (with heading)',
                abbr: 'csvfile',
               },
}


export function OutputGraph_xy_distill({bgData, stage0, stagesUp, stagesDn, lang}) {
    const chartRef = useRef(null);
    const width = 330, height = 320;

    const x1_cap_cn = 'x1', x1_cap_en = 'x1';
    const x1_cap = (lang===CN) ? x1_cap_cn : x1_cap_en;

    const y1_cap_cn = 'y1', y1_cap_en = 'y1';
    const y1_cap = (lang===CN) ? y1_cap_cn : y1_cap_en;
    const {x1s, y1s} = bgData;
    const xs0 = [stage0.x1, stage0.x1], ys0 = [stage0.x1,stage0.y1];

    //const [axisScale, setAxisScale] = useState('linear');

    const  axisScale='linear';

    useEffect( ()=> {

        const margin = { top: 20, right: 30, bottom: 40, left: 40 };


        const svg = d3.select(chartRef.current);
        svg.selectAll('*').remove();
     

        const xScale = d3.scaleLinear()
                        .domain([0, 1])
                        .range([margin.left, width-margin.right]);
        
        
        let yScale = d3.scaleLinear()
                        .domain([0,1])
                        .range([height-margin.bottom, margin.top]);
        
        if (axisScale === 'log') yScale = d3.scaleLog()
                                            .domain([1e-3, 10])
                                            .range([height-margin.bottom, margin.top]);

        if (x1s.length >0) {

            const line_x_x = d3.line()
                           .x((d,i)=>xScale(x1s[i]))
                           .y((d,i)=>yScale(x1s[i]));

            const line_y_x = d3.line()
                           .x((d,i)=>xScale(x1s[i]))
                           .y((d,i)=>yScale(y1s[i]));

            const line_stage0 = d3.line()
                           .x((d,i)=>xScale(xs0[i]))
                           .y((d,i)=>yScale(ys0[i]));

            svg.append("path").datum(x1s)
               .attr("stroke", "black").attr("fill",'none').attr("d",line_x_x);
            svg.append("path").datum(y1s)
               .attr("stroke", "black").attr("fill",'none').attr("d",line_y_x);
            svg.append("path").datum(ys0)
               .attr("stroke", "green").attr("fill",'none').attr("d",line_stage0);
        }

        if (stagesUp.length>0) {
            stagesUp.map((s0)=>{
                const {x1_prev, x1, y1, T} = s0;
                const xv = [x1, x1], yv = [x1,y1], xh = [x1_prev, x1], yh = [x1,x1];

                const line_v_up = d3.line()
                           .x((d,i)=>xScale(xv[i]))
                           .y((d,i)=>yScale(yv[i]));
                const line_h_up = d3.line()
                           .x((d,i)=>xScale(xh[i]))
                           .y((d,i)=>yScale(yh[i]));    
                svg.append("path").datum(yv)
                           .attr("stroke", "blue").attr("fill",'none').attr("d",line_v_up);
                svg.append("path").datum(yh)
                           .attr("stroke", "blue").attr("fill",'none').attr("d",line_h_up);            

            } )



        }

        //test
        if (stagesDn.length>0) {
            stagesDn.map((s0)=>{
                const {y1, x1, T} = s0;
                const xv = [x1, x1], yv = [x1,y1], xh = [y1,x1], yh = [y1,y1];

                const line_v_dn = d3.line()
                           .x((d,i)=>xScale(xv[i]))
                           .y((d,i)=>yScale(yv[i]));
                const line_h_dn = d3.line()
                           .x((d,i)=>xScale(xh[i]))
                           .y((d,i)=>yScale(yh[i]));    
                svg.append("path").datum(yv)
                           .attr("stroke", "red").attr("fill",'none').attr("d",line_v_dn);
                svg.append("path").datum(yh)
                           .attr("stroke", "red").attr("fill",'none').attr("d",line_h_dn);            

            } )



                }       

        const XaxisGenerator = d3.axisBottom(xScale);
        svg.append("g").call(XaxisGenerator).attr('transform', `translate(0,${height - margin.bottom})`);

        const XaxisGenerator2 = d3.axisTop(xScale);
        svg.append("g").call(XaxisGenerator2).attr('transform', `translate(0,${margin.top})`);

        const YaxisGenerator = d3.axisLeft(yScale);
        svg.append("g").call(YaxisGenerator).attr('transform', `translate(${margin.left},0)`);

        const YaxisGenerator2 = d3.axisRight(yScale);
        svg.append("g").call(YaxisGenerator2).attr('transform', `translate(${width - margin.right},0)`);

        svg.append("text")             
            .attr("transform", `translate(${width/2},${height-8})`)
            .style("text-anchor", "middle") // Centers the text above the axis
            .text(x1_cap);

        svg.append("text")
            .attr("transform", `translate(${12},${height/2-8}), rotate(-90)`) // Rotates the text -90 degrees
            .style("text-anchor", "middle") // Ensures the text is centered after rotation
            .text(y1_cap);

    }, [bgData,lang]);



    return (
        <div>
            <svg width={width+'px'} height={height+'px'} ref={chartRef} />
        </div>
    );
}


export function DistillationColumn({ stage0, stagesUp, stagesDn,comps, lang }){
    const chartRef = useRef();
    const spacing = 32;
    const width = 390, height = (stagesUp.length + stagesDn.length + 1) * spacing + 60, topMargin = 40;
    const widthTower = 60, posLabel = widthTower + 6, towerLeft = 110, towerTop = 60, heightTower = height-80;
    const topCap = (lang===CN) ? "塔顶产品:" : 'Top Product:';
    const bottomCap = (lang===CN) ? '塔底产品:' : 'Bottom Product:';

    //Find composition of top product and bottom product:
    const y1Top = (stagesUp.length > 0) ? stagesUp[stagesUp.length-1].y1 : stage0.y1;
    const x2Bottom = (stagesDn.length > 0) ? (1 - stagesDn[stagesDn.length-1].x1) : (1-stage0.x1);

    useEffect(() => {

        const svg = d3.select(chartRef.current)
            .attr('width', width)
            .attr('height', height+topMargin); // Adjust height for the arrow

        svg.selectAll('*').remove();

         // Draw tower background
        svg.append('rect')
            .attr('x', towerLeft)
            .attr('y', towerTop)
            .attr('width', widthTower)  // Reduced width for the column
            .attr('height', heightTower)
            .attr('fill', 'white')
            .attr('stroke', 'black')
            .attr('stroke-width', '2');

        
        const arc_up = d3.arc()
            .innerRadius(0)
            .outerRadius(widthTower*0.5) // Radius of the semi-circle
            .startAngle(-Math.PI*0.5) // Start angle, at the left end of the diameter
            .endAngle(Math.PI*0.5);        // End angle, at the right end of the diameter
        const arc_dn = d3.arc()
            .innerRadius(0)
            .outerRadius(widthTower*0.5) // Radius of the semi-circle
            .startAngle(Math.PI*0.5) // Start angle, at the left end of the diameter
            .endAngle(Math.PI*1.5);        // End angle, at the right end of the diameter
    
        // Put top and bottom arc for the column
        svg.append("path")
            .attr("d", arc_up)
            .attr("fill", "white")
            .attr("stroke", "black")
            .attr("stroke-width", 2)
            .attr("transform", `translate(${towerLeft+widthTower*0.5}, ${towerTop})`);
        svg.append("path")
            .attr("d", arc_dn)
            .attr("fill", "white")
            .attr("stroke", "black")
            .attr("stroke-width", 2)
            .attr("transform", `translate(${towerLeft+widthTower*0.5}, ${towerTop+heightTower})`);

        // Function to draw stages as lines and labels
        const drawStage = (data, yOffset, sign = 1, reverse = false) => {
            if (reverse) {
                data = data.slice().reverse(); // Reverse the data for stagesUp
            }
            const groups = svg.selectAll('.stage-group')
                .data(data)
                .enter()
                .append('g')
                .attr('transform', (d, i) => `translate(${towerLeft}, ${yOffset + i * spacing + 25})`); // Center line in stage space

            groups.append('line')
                .attr('x1', 0)
                .attr('x2', widthTower)  // Matching the reduced width of the column
                .attr('stroke', reverse ? 'blue' : 'red')  // Blue for stagesUp, Red for stagesDn
                .attr('stroke-width', 10);

            groups.append('text')
                .attr('x', posLabel)  // Position labels to the right of the column
                .attr('y', 0)
                .attr('dominant-baseline', 'middle')
                .attr('text-anchor', 'start')
                .text((d, i) => `S${sign * (reverse ? data.length - i : i + 1)}: ${reverse? 'y1': 'x2'}=${reverse? (d.y1*100).toFixed(2) : ((1-d.x1)*100).toFixed(2)}%, T=${(d.T - 273.15).toFixed(2)}°C`);
        };

        // Draw stages above the feed in reversed order
        drawStage(stagesUp, 40, 1, true);

        // Draw feed stage as a line
        const feedGroup = svg.append('g')
            .attr('transform', `translate(${towerLeft}, ${40 + stagesUp.length * spacing + 25})`);
        feedGroup.append('line')
            .attr('x1', 0)
            .attr('x2', widthTower)  // Matching the reduced width of the column
            .attr('stroke', 'green')  // Green for stage0
            .attr('stroke-width', 10);

        feedGroup.append('text')
            .attr('x', posLabel)  // Position labels to the right of the column
            .attr('y', 0)
            .attr('dominant-baseline', 'middle')
            .attr('text-anchor', 'start')
            .text(`S0: x1=${(stage0.x1*100).toFixed(2)}%, y1=${(stage0.y1*100).toFixed(2)}%`);

        // Draw stages below the feed
        drawStage(stagesDn, 40 + (stagesUp.length + 1) * spacing, -1, false);

        // Draw an arrow for feed
        const arrowY = 40 + stagesUp.length * spacing + 25;  // Center of the Stage 0
        svg.append('line')
            .attr('x1', 10)
            .attr('y1', arrowY)
            .attr('x2', towerLeft-10)
            .attr('y2', arrowY)
            .attr('stroke', 'black')
            .attr('stroke-width', 5)  // Thicker line but thinner than the stages
            .attr('marker-end', 'url(#arrow)');
        svg.append('text')
            .attr('x', 10)  // Position labels to the right of the column
            .attr('y', arrowY-8)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`${comps[0]}/${comps[1]}`);
        svg.append('text')
            .attr('x', 10)  // Position labels to the right of the column
            .attr('y', arrowY+16)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`x1=${(stage0.x1*100).toFixed(2)}%`);
        svg.append('text')
            .attr('x', 10)  // Position labels to the right of the column
            .attr('y', arrowY+32)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`T=${(stage0.T - 273.15).toFixed(2)}°C`);
        // Additional arrows
        // Top arrow (up and then right)
        svg.append('path')
            .attr('d', `M ${towerLeft+widthTower/2},40 L ${towerLeft+widthTower/2},20 L 200,20`)
            .attr('stroke', 'black')
            .attr('stroke-width', 4)
            .attr('fill', 'none')
            .attr('marker-end', 'url(#arrow)');
        svg.append('text')
            .attr('x', 210)  // Position labels to the right of the column
            .attr('y', 20-6)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`${topCap}`);
        svg.append('text')
            .attr('x', 210)  // Position labels to the right of the column
            .attr('y', 20+16)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`${comps[0]} (${(y1Top*100).toFixed(2)}%mol)`);

        // Bottom arrow (down and then right)
        svg.append('path')
            .attr('d', `M ${towerLeft+widthTower/2},${height} L ${towerLeft+widthTower/2},${height + 20} L 200,${height + 20}`)
            .attr('stroke', 'black')
            .attr('stroke-width', 4)
            .attr('fill', 'none')
            .attr('marker-end', 'url(#arrow)');
        svg.append('text')
            .attr('x', 210)  // Position labels to the right of the column
            .attr('y', height + 20-6)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`${bottomCap}`);
        svg.append('text')
            .attr('x', 210)  // Position labels to the right of the column
            .attr('y', height + 20+16)
            .attr('dominant-baseline', 'bottom')
            .attr('text-anchor', 'start')
            .text(`${comps[1]} (${(x2Bottom*100).toFixed(2)}%mol)`);

        // Define the arrowhead
        svg.append('defs').append('marker')
            .attr('id', 'arrow')
            .attr('viewBox', '0 0 10 10')
            .attr('refX', 1)  // Adjust the arrowhead position to touch the box
            .attr('refY', 5)
            .attr('markerWidth', 2)
            .attr('markerHeight', 2)
            .attr('orient', 'auto')
            .append('path')
            .attr('d', 'M 0 0 L 10 5 L 0 10 z');

    }, [stage0, stagesUp, stagesDn, comps, lang]); // Dependencies

    return (
        <div>
            <svg width={width+'px'} height={(height+topMargin)+'px'} ref={chartRef}/>
        </div>

    );
};
